<template>
  <v-app color>
    <v-content class>
      <v-container fill-height class="d-flex justify-center">
        <v-card
          width="450"
          height="500"
          :loading="disableCard"
          :outlined="true"
          flat
          :disabled="disableCard"
          class="pl-8 pr-8"
        >
          <v-card-title>
            <v-img
              width="20"
              height="32"
              :src="require('@/assets/google_logo.png')"
              :contain="true"
              class="mt-8"
            />
          </v-card-title>
          <v-card-text>
            <h3 class="headline text-center text--primary">Ticket Submited</h3>

            <div class="text-center">
              <v-btn
                :rounded="true"
                class="ma-3 mx-auto email-button"
                :outlined="true"
              >
                <v-icon left>mdi-account-circle</v-icon>
                <div class="text--primary text-none">{{ email }}</div>
                <v-icon right>mdi-chevron-down</v-icon>
              </v-btn>
              <h4 class="text-left text--primary">
                Ticket 1012-232-002 has been submited and would be resolved.
              </h4>
            </div>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              :depressed="true"
              @click="submitForm"
              eight="36"
              width="88"
              class="text-none"
              >Continue</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
export default {
  name: "completeForm",
  data: () => ({
    email: "",
  }),

  async created() {
    this.email = this.$route.params.data.includes("@")
      ? this.$route.params.data
      : window.atob(this.$route.params.data).split(",")[0];
  },

  methods: {
    submitForm() {
      window.location.href = "https://mail.google.com";
    },
  },
};
</script>

<style lang="scss">
a {
  text-decoration: none;
  color: #005da6;
}
.rounded-button {
  border-radius: 0px;
}
.email-button {
  border: 0.5px solid rgb(219, 219, 219);
}
</style>